import { query } from './query'

export const caseStudyListingPageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
}
